const flights = {
  flight: "Penerbangan", // translated 
  flights: "Penerbangan", // translated 
  originDepartureDate: "Berlepas", // translated 
  destinationDepartureDate: "Pulangan", // translated 
  outbound: "Keluar", // translated 
  inbound: "Masuk", // translated 
  travelTime: "Masa perjalanan", // translated 
  selected: "dipilih", // translated 
  select: "pilih", // translated 
  airline: "Syarikat Penerbangan", // translated 
  directFlight: "Penerbangan terus", // translated 
  baggage: "Bagasi", // translated 
  stops: "Perhentian", // translated 
  nonStop: "Tanpa henti", // translated 
  oneStopMax: "Maksimum sehenti", // translated 
  twoStopsMax: "Maksimum dua hentian", // translated 
  anyStops: "Dengan sebarang perhentian", // translated 
  smallBaggage: "Bagasi kecil", // translated 
  bigBaggage: "Bagasi besar", // translated 
  smallAndBigBaggage: "Bagasi kecil dan besar", // translated 
  outboundStops: "Perhentian keluar", // translated 
  inboundStops: "Perhentian masuk", // translated 
  selectAirline: "Pilih Syarikat Penerbangan", // translated 
  baggageOption: "Pilihan bagasi", // translated 
  outboundDepartureAfter: "Pelepasan keluar selepas", // translated 
  outboundArrivalAfter: "Ketibaan keluar selepas", // translated 
  inboundDepartureAfter: "Pelepasan masuk selepas", // translated 
  inboundArrivalTimeAfter: "Ketibaan masuk selepas", // translated 
  flightClass: "Kelas penerbangan", // translated 
  outboundDepAfter: "Keluar selepas", // translated 
  outboundArrivalAfrer: "Ketibaan keluar selepas", // translated 
  inboundDepAfter: "Dalam pemergian selepas", // translated 
  inboundArrivalAfter: "Dalam ketibaan selepas", // translated 
  airlines: "Syarikat Penerbangan", // translated 
  lessThan: "Kurang daripada", // translated 
  layover: "Persinggahan", // translated 
  duration: "Tempoh", // translated 
  noClassPreference: "Tiada Keutamaan Kelas", // translated 
  economy: "Ekonomi", // translated 
  business: "Perniagaan", // translated 
  with: "Dengan", // translated 
  without: "Tanpa", // translated 
  twoOrMore: "Dua atau lebih", // translated 
  departure: "Berlepas", // translated 
  return: "Pulangan", // translated 
  submit: "Hantar", // translated 
  priceLessThan: "Harga kurang daripada", // translated 
  durationLessThan: "Tempoh kurang daripada", // translated 
  layoverLessThan: "Persinggahan kurang daripada", // translated 
  noLayover: "Tiada persinggahan", // translated 
  durationLowestFirst: "Tempoh (terendah dahulu)", // translated 
  durationHighestFirst: "Tempoh (tertinggi dahulu)", // translated 
  idType: "Jenis ID", // translated 
  idPassportCode: "Kod ID/Pasport", // translated 
  expirationDate: "Tarikh Luput", // translated 
  frequentFlyerNumber: "Nombor Penerbangan Kerap", // translated 
  frequentFlyerAirline: "Syarikat Penerbangan Kerap", // translated 
  dateOfBirth: "Tarikh Lahir", // translated 
  infant: "Bayi", // translated 
  phone: "Telefon", // translated 
  title: "Tajuk", // translated 
  noLuggageIncluded: "Tiada Bagasi Termasuk", // translated 
  includesLuggage: "Termasuk Bagasi", // translated 
  outboundFlight: "Penerbangan Keluar", // translated 
  inboundFlight: "Penerbangan Masuk", // translated 
  flightNumber: "Nombor Penerbangan", // translated 
  flightNumbers: "Nombor Penerbangan", // translated 
  cabinClassType: "Jenis Kelas Kabin", // translated 
  class: "Kelas", // translated 
  aircraft: "Pesawat", // translated 
  aircraftType: "Jenis Pesawat", // translated 
  airlineName: "Nama Syarikat Penerbangan", // translated 
  no: "Tidak", // translated 
  yes: "Ya", // translated 
  anyFlights: "Sebarang Penerbangan", // translated 
  oneStop: "Satu Hentian", // translated 
  direct: "Langsung", // translated 
  directFlights: "Penerbangan Terus", // translated 
  all: "Semua", // translated 
  first: "Pertama", // translated 
  premiumEconomy: "Ekonomi Prem.", // translated 
  withBaggageOnly: "Dengan Bagasi Sahaja", // translated 
  oneWay: "Sehala", // translated 
  roundTrip: "Perjalanan Pergi Balik", // translated 
  withBaggage: "Dengan Bagasi", // translated 
  noBaggagePreference: "Tiada Keutamaan Bagasi", // translated 
  noBaggage: "Tiada Bagasi", // translated 
  requiredFields: "Medan Wajib", // translated 
  nonRequiredFields: "Medan Tidak Wajib Diisi", // translated 
  cabinClass: "Kelas Kabin", // translated 
  brandName: "Nama Jenama", // translated 
  performNewSearch: "Lakukan carian baharu", // translated 
  outboundDeparture: "Pelepasan Keluar", // translated 
  inboundDeparture: "Pelepasan Masuk", // translated 
  created: "Dicipta", // translated 
  freeCancellationAvailable: "Pembatalan Percuma Tersedia", // translated 
  freeCancellationDeadline: "Tarikh Akhir Pembatalan Percuma", // translated 
  externalReference: "Rujukan Luaran", // translated 
  outboundflightNumber: "Nombor Penerbangan Keluar", // translated 
  inboundflightNumber: "Nombor Penerbangan Masuk", // translated 
  arrival: "Ketibaan", // translated 
  originAirport: "Lapangan Terbang Asal", // translated 
};







export default flights;
